// src/pages/Operator/UpdateWartaTata/UpdateWartaTata.jsx (FINAL)

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Footer, NavBarLogin } from "../../../components"; 
// PASTIKAN PATH DI ATAS BENAR: ../../../components
// IMPORT FIREBASE REALTIME DB, STORAGE, DAN AUTH
import { db, storage, auth } from "../../../config/firebase"; 
// PASTIKAN PATH DI ATAS BENAR: ../../../config/firebase
import { ref as dbRef, set, onValue } from "firebase/database";
import { ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import "./updateWartaTata.scss"; 

// Node di Realtime Database untuk menyimpan URL PDF dan metadata
const DB_NODE = "pdf_links";

const UpdateWartaTata = () => {
    const navigate = useNavigate();
    const [wartaFile, setWartaFile] = useState(null);
    const [tataFile, setTataFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    
    // State untuk menampung link dan metadata dari DB
    const [currentLinks, setCurrentLinks] = useState({ warta: "Memuat...", tata: "Memuat..." });
    const [currentMetadata, setCurrentMetadata] = useState(null); 
    
    // Asumsi: Ambil data pengguna dari Firebase Auth
    const currentUser = auth.currentUser;
    // Tentukan nama yang akan disimpan (Fallback jika tidak ada auth)
    const uploadedBy = currentUser ? (currentUser.email || "Operator Terotentikasi") : "Operator Lokal"; 


    // Fungsi Pembantu untuk Format Tanggal dan Teks
    const formatMeta = (meta) => {
        if (!meta || !meta.timestamp) return "Data belum pernah diunggah.";

        const date = new Date(meta.timestamp);
        const formattedDate = date.toLocaleDateString('id-ID', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
        
        const operatorName = meta.uploadedBy || 'Tidak Diketahui';

        return `${formattedDate} oleh ${operatorName}`;
    };


    // 1. Ambil Link & Metadata Saat Ini dari Firebase DB
    useEffect(() => {
        const linksRef = dbRef(db, DB_NODE);
        const unsubscribe = onValue(linksRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                setCurrentLinks({ 
                    warta: data.warta || "Belum ada link", 
                    tata: data.tata || "Belum ada link" 
                });
                setCurrentMetadata(data); 
            }
        });
        return () => unsubscribe();
    }, []);
    
    // 💡 FUNGSI VALIDASI PDF BARU
    const handleFileChange = (e, setFileState, typeName) => {
        const file = e.target.files[0];
        setMessage(""); // Bersihkan pesan error sebelumnya

        if (file) {
            if (file.type === "application/pdf") {
                setFileState(file);
            } else {
                setMessage(`❌ File ${typeName} harus berformat PDF.`);
                setFileState(null);
                // Penting: Reset input file agar pengguna dapat memilih lagi
                e.target.value = ''; 
            }
        } else {
            setFileState(null);
        }
    };

    // 2. Fungsi Upload File ke Storage (TIDAK BERUBAH)
    const uploadFile = async (file, type) => {
        if (!file) return null;

        const fileName = `${type}_Jemaat.pdf`; 
        const fileStorageRef = storageRef(storage, `warta_tata/${fileName}`);
        
        const snapshot = await uploadBytes(fileStorageRef, file);
        
        const url = await getDownloadURL(snapshot.ref);
        return url;
    };

    // 3. Handler Submit Utama
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");

        // Validasi Akhir sebelum mulai upload
        if (!wartaFile && !tataFile) {
            setMessage("❌ Harap pilih minimal satu file PDF untuk diupdate.");
            setLoading(false);
            return;
        }

        try {
            const newTimestamp = new Date().toISOString();
            let updatedData = { ...currentMetadata }; 

            // --- Proses Warta Jemaat ---
            if (wartaFile) {
                const wartaUrl = await uploadFile(wartaFile, "warta");
                updatedData.warta = wartaUrl;
                updatedData.warta_meta = {
                    timestamp: newTimestamp,
                    uploadedBy: uploadedBy,
                };
            } else if (!updatedData.warta) {
                updatedData.warta = currentLinks.warta;
            }

            // --- Proses Tata Ibadah ---
            if (tataFile) {
                const tataUrl = await uploadFile(tataFile, "tata");
                updatedData.tata = tataUrl;
                updatedData.tata_meta = {
                    timestamp: newTimestamp,
                    uploadedBy: uploadedBy,
                };
            } else if (!updatedData.tata) {
                updatedData.tata = currentLinks.tata;
            }

            // Simpan semua data yang diperbarui ke Realtime Database
            await set(dbRef(db, DB_NODE), updatedData);

            setMessage("✅ PDF berhasil diupload dan link serta metadata telah diupdate!");
            setWartaFile(null); 
            setTataFile(null);
            document.getElementById('warta-input').value = null; 
            document.getElementById('tata-input').value = null; 

        } catch (error) {
            console.error("Error saat upload atau update DB:", error);
            setMessage(`❌ Gagal mengupdate file: ${error.message}`);
        } finally {
            setLoading(false);
            setTimeout(() => setMessage(""), 5000);
        }
    };

    return (
        <div className="update-pdf-page">
            <NavBarLogin />
            <section className="update-form-section">
                
                <div className="form-header-action">
                    <button 
                        onClick={() => navigate('/operator')} 
                        className="stylish-back-button" 
                        disabled={loading}
                    >
                        <span aria-hidden="true"> ← </span> Dashboard Operator
                    </button>
                    <div className="header-content">
                        <h2>📤 Update Warta & Tata Ibadah</h2>
                        <p>Upload file PDF baru untuk menggantikan file yang lama. Anda dapat mengupdate salah satu atau keduanya. **Diunggah sebagai: {uploadedBy}**</p>
                    </div>
                </div>
                
                <form onSubmit={handleSubmit} className="pdf-upload-form">
                    
                    {/* Input Warta Jemaat */}
                    <div className="upload-group">
                        <h3>Warta Jemaat Mingguan (.PDF)</h3>
                        <p className="current-link-info">
                            **Terakhir Diperbarui:** {formatMeta(currentMetadata?.warta_meta)}
                        </p>
                        <div className="form-group">
                            <label htmlFor="warta-input">Pilih File Warta Jemaat:</label>
                            <input
                                id="warta-input"
                                type="file"
                                accept=".pdf"
                                // 💡 Panggil fungsi validasi di sini
                                onChange={(e) => handleFileChange(e, setWartaFile, 'Warta Jemaat')}
                            />
                        </div>
                        <p className="current-link-info">
                            **Link Saat Ini:** {currentLinks.warta.length > 50 ? 'Sudah terisi (Link Stabil)' : currentLinks.warta}
                        </p>
                        {wartaFile && (
                            <p className="file-ready">**File siap diupload:** {wartaFile.name}</p>
                        )}
                    </div>

                    {/* Input Tata Ibadah */}
                    <div className="upload-group">
                        <h3>Tata Ibadah Mingguan (.PDF)</h3>
                        <p className="current-link-info">
                            **Terakhir Diperbarui:** {formatMeta(currentMetadata?.tata_meta)}
                        </p>
                        <div className="form-group">
                            <label htmlFor="tata-input">Pilih File Tata Ibadah:</label>
                            <input
                                id="tata-input"
                                type="file"
                                accept=".pdf"
                                // 💡 Panggil fungsi validasi di sini
                                onChange={(e) => handleFileChange(e, setTataFile, 'Tata Ibadah')}
                            />
                        </div>
                        <p className="current-link-info">
                            **Link Saat Ini:** {currentLinks.tata.length > 50 ? 'Sudah terisi (Link Stabil)' : currentLinks.tata}
                        </p>
                        {tataFile && (
                            <p className="file-ready">**File siap diupload:** {tataFile.name}</p>
                        )}
                    </div>
                    
                    <button type="submit" disabled={loading || (wartaFile === null && tataFile === null)}>
                        {loading ? "Mengupload & Menyimpan..." : "Upload dan Simpan Link PDF"}
                    </button>
                    
                    {message && <p className={`message ${message.startsWith('✅') ? 'success' : 'error'}`}>{message}</p>}
                </form>
            </section>
            <Footer />
        </div>
    );
};

export default UpdateWartaTata;